import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { MatInputModule } from '@angular/material/input';

import {
  CustomResultOfInboxesByParserWithPaginationDto,
  PollParserType,
} from 'src/app/core/api/models';
import { ExcelService, InboxesService } from 'src/app/core/api/services';
import { AppDomService } from 'src/app/core/services/dom.service';
import { EventTypes } from '../../../../core/constants/event-types';
import { BaseIndexPageComponent } from '../../../shared/base/components/base-index-page.component';
import { CreatePollParserInboxExcelDialogComponent } from './create-poll-parser-inbox-excel/create-poll-parser-inbox-excel-dialog.component';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { SmsBodyModule } from 'src/app/shared/components/sms-body/sms-body.module';


@Component({
    selector: 'app-poll-parser-inboxes',
    templateUrl: './poll-parser-inboxes.component.html',
    styleUrls: ['./poll-parser-inboxes.component.scss'],
    imports: [
        BaseIndexModule,
        MatInputModule,
        SmsBodyModule
    ]
})
export class PollParserInboxesComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  pageName = 'pollParsersInboxes';
  get PollParserType() {
    return PollParserType;
  }

  @Input('pollParserId') id: any;
  @Input() targetAnswer: any;
  @Input() pollParserFormula: any;

  @Output('closePollParserInboxesPage') output_closePollParserInboxesPage =
    new EventEmitter<boolean>();

  constructor(
    protected currentService: InboxesService,
    protected excelFileService: ExcelService
  ) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.showHelpBtn = false;
      this.pageConfig.showRefreshBtn = true;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  setDefaultTableSort(): void {
    this.sortObject.push({ columnName: 'dateTimeReceive', sort: 1 });
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: this.localizer.senderNumber,
        name: 'senderMobile',
        hasSearch: true,
        noSorting: false,
      },
      {
        title: this.localizer.privateNumber,
        name: 'ReceiverPrivateNumber.Number',
        hasSearch: true,
        noSorting: false,
      },
      {
        title: this.localizer.smsText,
        name: 'smsText',
        hasSearch: true,
        noSorting: false,
      },
      {
        title: this.localizer.receiveDateTime,
        name: 'dateTimeReceive',
        hasSearch: true,
        noSorting: false,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  getPaginationApi(): Observable<CustomResultOfInboxesByParserWithPaginationDto> {
    return this.currentService.inboxesGetInboxesByPollParserIdWIthPagination({
      body: {
        ...this.getBaseModelWithPaginationParams(),
        pollParserId: this.id,
        targetAnswer: this.targetAnswer,
      },
    });
  }

  InboxExcelReportApi() {
    this.excelFileService
      .excelCreateInboxesExcelByPollParserGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          let data = {
            title: `${this.pageVocabs}inboxesExcel`,
            pollParserId: this.id,
            targetAnswer: this.targetAnswer,
            comparisonObjects: this.comparisonObjects,
            sortObject: this.sortObject,
          };

          const modalResult = this.dialogService.openModal({
            component: CreatePollParserInboxExcelDialogComponent,
            data: data,
          });

          modalResult
            .afterClosed()
            .pipe(
              takeUntil(this.onDestroy$),
              tap(() => {
                AppDomService.removeModalScrollClassFromHtml();
              })
            )
            .subscribe();
        }
      });
  }

  //#endregion
  onBack() {
    this.output_closePollParserInboxesPage.emit(true);
  }

  onExcelReport() {
    this.InboxExcelReportApi();
  }
}
